import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import Paper from "@mui/material/Paper";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import { useLanguage } from "context/LanguageContext";

function LanguageSwitcher() {
  const { language, setLanguage, messages } = useLanguage();

  return (
    <Paper
      elevation={8}
      sx={{
        position: "fixed",
        top: 16,
        right: 16,
        zIndex: 1400,
        px: 1.5,
        py: 1,
        borderRadius: "999px",
        backdropFilter: "blur(14px)",
        backgroundColor: "rgba(255, 255, 255, 0.92)",
      }}
    >
      <MKBox display="flex" alignItems="center" gap={1.5}>
        <MKTypography variant="button" fontWeight="bold" color="dark">
          {messages.languageSwitcher.label}
        </MKTypography>
        <ButtonGroup size="small" variant="contained" aria-label={messages.languageSwitcher.label}>
          <Button color={language === "es" ? "info" : "inherit"} onClick={() => setLanguage("es")}>
            {messages.languageSwitcher.es}
          </Button>
          <Button color={language === "en" ? "info" : "inherit"} onClick={() => setLanguage("en")}>
            {messages.languageSwitcher.en}
          </Button>
        </ButtonGroup>
      </MKBox>
    </Paper>
  );
}

export default LanguageSwitcher;
